<app-generic-border-template [header]="'LATEST PEND'">
  <div *ngIf="chaseDetailState.hasPend; else noActivePends" class="bold">
    <span>Pend </span><a routerLink="{{this.pendURL}}">{{chaseDetailState.chasePendId}}</a> - {{pendInfo}}
  </div>
  <ng-template #noActivePends>
    <span class="bold">No Active Pends</span>
  </ng-template>
</app-generic-border-template>